module.exports = __webpack_public_path__ + "Poppins-BoldItalic.14da6265bd17503342b1.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-BoldItalic.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-BoldItalic.woff
// module chunks = styles